module.exports = __webpack_public_path__ + "static/media/Popcorn.ed2c754f.glb";